import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BaseComponent } from '../../shared/class/base-component.class';
import { MessageType } from '../../shared/enums/message-type.enum';
import { ActiveSubscription } from '../../subscription/models/active-subscription';

@Component({
  selector: 'app-layout-container',
  templateUrl: './layout-container.component.html',
  styleUrl: './layout-container.component.scss'
})
export class LayoutContainerComponent extends BaseComponent implements OnInit{
  userMenuItems: MenuItem[] = [];
  searchVisible = false;
  activeSubscription: ActiveSubscription | undefined;

  constructor(  router: Router) {
    super()
  }


  ngOnInit() {
    this.userMenuItems = [
      {
        label: 'Settings',
        icon: 'pi pi-cog',
        command: () => this.router.navigateByUrl('settings')
      },
      { separator: true },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this.logout()
      }
    ];
    this.activeSubscription = this.userService.getActiveSubscription();
  }


  toggleSearch() {
    this.searchVisible = !this.searchVisible;
  }


  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('exp');
    this.router.navigate(['/auth/login']);
    this.notificationService.notify("Logout Successfully",MessageType.Success);
  }

}
